export default "__VITE_ASSET__847066c5__"